import { FC, useState } from 'react';

import { MoreBox } from '@assets/icons';
import { PermissionAccess, PopperPortal } from '@components/index';

import { LABEL_ACTION_MAP } from './constants';
import { ContentModalActionType, Label } from './types';

type Props = {
  data: Label;
  handleActionClick: (data: Label, action: ContentModalActionType) => void;
  isInheritedLabel?: boolean;
};

export const SelectMoreAction: FC<Props> = props => {
  const { data, handleActionClick, isInheritedLabel = false } = props;

  const [isSelectMoreActionOpen, setIsSelectMoreActionOpen] = useState(false);

  // Filter actions for inherited labels - only show metadata
  const filteredActionMap = isInheritedLabel
    ? LABEL_ACTION_MAP.filter(
        action => action.action === ContentModalActionType.LABEL_METADATA,
      )
    : LABEL_ACTION_MAP;

  return (
    <PopperPortal
      refComponent={() => (
        <MoreBox
          className="cursor-pointer text-text-primary hover:text-text-secondary"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            setIsSelectMoreActionOpen(true);
          }}
        />
      )}
      popComponent={() => (
        <div
          className="px-2 py-3"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {filteredActionMap.map(({ label, Icon, action, permission }) => (
            <PermissionAccess
              key={label}
              hasPermission={!permission}
              permission={permission}
              AllowedContent={
                <div
                  className="h-8 px-0.5 py-2 flex gap-3 cursor-pointer hover:bg-modal-surface-hover text-sm w-[110px] rounded-sm"
                  onClick={() => {
                    handleActionClick(data, action);
                    setIsSelectMoreActionOpen(false);
                  }}
                >
                  {Icon && <Icon className="h-4 w-4" />}
                  <span>{label}</span>
                </div>
              }
            />
          ))}
        </div>
      )}
      placement="bottom-end"
      controlledIsOpen={isSelectMoreActionOpen}
      handleControlledIsOpen={setIsSelectMoreActionOpen}
    />
  );
};
